import { useContext, useState } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";


export function CabinetHeightSetter(props: React.HTMLProps<HTMLInputElement>) {

    const ec = useContext(EditorContext);

    const [heightStr, setHeightStr] = useState(ec.cabinet.height?.toString() ?? "");
    async function setHeight() {
        const height = parseInt(heightStr)
        const result = await ec.cabinetService.setCabinetHeight(height);
        if (result.success) {
            setHeightStr(result.actualHeight.toString());
        }
        else {
            setHeightStr(ec.cabinet.height?.toString() ?? "");
        }
    }

    const text = ec.translator("dimensions height placeholder", "Højde")

    return (
        <input
            {...props}
            value={heightStr}
            onChange={evt => setHeightStr(evt.target.value)}
            onBlur={setHeight}
            title={text}
            placeholder={text}
            min={ec.cabinetService.getProductLine()?.minSize.x}
            max={ec.cabinetService.getProductLine()?.maxSize.x}
        />
        
    );
}
